import { useTranslation } from 'react-i18next';
export const SelectAll = ({
  onClear,
  onSelectAll,
  filtered,
  onSelectFiltered,
  fetchNextPage,
  hasNextPage,
}: {
  onSelectAll: () => void;
  onClear: () => void;
  filtered?: boolean;
  onSelectFiltered?: () => void;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}) => {
  const { t } = useTranslation('designSystem');
  const style =
    'text-xs hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-400 font-medium p-1 rounded-md';
  return (
    <div className="flex justify-end gap-2 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-[4px]">
      {filtered && (
        <button className={style} onClick={onSelectFiltered}>
          {t('selectFiltered')}
        </button>
      )}
      {!(fetchNextPage && hasNextPage) && (
        <button className={style} onClick={onSelectAll}>
          {t('selectAll')}
        </button>
      )}
      <button className={style} onClick={onClear}>
        {t('clear')}
      </button>
    </div>
  );
};
